import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  Avatar,
  Typography,
  Box,
  Chip,
  Divider,
} from '@mui/material';
import { History as HistoryIcon, Person as PersonIcon } from '@mui/icons-material';

const LogHistoryDialog = ({ open, log, onClose }) => {
  if (!log) return null;

  const getStatusColor = (status) => {
    const colors = {
      new: 'info',
      'in-progress': 'warning',
      'waiting-client': 'secondary',
      completed: 'success',
    };
    return colors[status] || 'default';
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Status History: {log.title}</DialogTitle>
      <DialogContent>
        {log.statusHistory && log.statusHistory.length > 0 ? (
          <List>
            {log.statusHistory.map((entry, idx) => (
              <React.Fragment key={idx}>
                <ListItem alignItems="flex-start" sx={{ flexDirection: 'column', alignItems: 'stretch' }}>
                  {/* Header with avatar and status */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                    <Avatar sx={{ bgcolor: `${getStatusColor(entry.status)}.main` }}>
                      <HistoryIcon />
                    </Avatar>
                    <Box sx={{ flex: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                        <Typography variant="subtitle1" fontWeight={500}>
                          Status changed to: {entry.status}
                        </Typography>
                        <Chip
                          label={entry.status}
                          size="small"
                          color={getStatusColor(entry.status)}
                        />
                      </Box>
                    </Box>
                  </Box>

                  {/* User info */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 7, mb: 1 }}>
                    <PersonIcon fontSize="small" color="action" />
                    <Typography variant="caption" color="textSecondary">
                      Changed by: {entry.changedBy?.fullName || 'Unknown'}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      at {formatDate(entry.changedAt)}
                    </Typography>
                  </Box>

                  {/* Notes */}
                  {entry.notes && (
                    <Box sx={{ ml: 7, mt: 1, p: 1, bgcolor: 'action.hover', borderRadius: 1 }}>
                      <Typography variant="body2">
                        <strong>Notes:</strong> {entry.notes}
                      </Typography>
                    </Box>
                  )}
                </ListItem>
                {idx < log.statusHistory.length - 1 && <Divider variant="inset" component="li" />}
              </React.Fragment>
            ))}
          </List>
        ) : (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography color="textSecondary">
              No status changes recorded.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogHistoryDialog;